import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { testTimezone } from "./../../actions/UserActions";
import { connect } from "react-redux";
import setHours from "date-fns/setHours";
import setMinutes from "date-fns/setMinutes";
import "react-datepicker/dist/react-datepicker.css";

function TimezoneTest({ testTimezone }) {
  const [selectedDate, setDate] = useState(new Date());
  const pickeddate = (data) => {
    // console.log("data", data);
    setDate(data);
    let senddata = {
      date: data,
    };
    testTimezone(senddata).then((response) => {
      // console.log(response);
    });
  };
  return (
    <div>
      DATE PICKER
      {/* <DatePicker
        minDate={new Date()}
        // selected={date}
        dateFormat="MM-dd-yyyy"
        className="form-control form-control-date pl-1 date-picker"
        timeZone="Asia/Kolkata"
        onChange={(date) => pickeddate(date)}
      /> */}
      {/* <DatePicker
        // selected={startDate}
        onChange={(date) => pickeddate(date)}
        showTimeSelect
        excludeTimes={[
          setHours(setMinutes(new Date(), 0), 17),
          setHours(setMinutes(new Date(), 30), 18),
          setHours(setMinutes(new Date(), 30), 19),
          setHours(setMinutes(new Date(), 30), 17),
        ]}
        dateFormat="MMMM d, yyyy h:mm aa"
      /> */}
      {/* <DatePicker
        selected={selectedDate}
        onChange={pickeddate}
        showTimeSelect
        timeFormat="HH:mm"
        dateFormat="MMMM d, yyyy h:mm aa"
        timeZone="Asia/Kolkata" // Set the timezone to Indian Standard Time
      /> */}
      <DatePicker
        selected={selectedDate}
        onChange={pickeddate}
        dateFormat="MM/dd/yyyy h:mm aa"
        showTimeSelect
        timeIntervals={15}
        timeCaption="Time"
        placeholderText="Select date and time"
      />
    </div>
  );
}

// export default TimezoneTest;

const mapStateToProps = (state) => {
  return {};
};

export default connect(
  mapStateToProps,
  {
    testTimezone,
  }
)(TimezoneTest);
